/* Elegancecoque - fiche produit : reprise du modèle d'iPhone (lien ?model=, collection d'origine ou modèle mémorisé) uniquement si une variante compatible existe, couleur (?color=), et choix du modèle obligatoire sinon */
(function(){
if(window.__luxePreselect){return;}
window.__luxePreselect=true;
var doc=document,E=window.ECModel;
function colls(){var n=doc.querySelector('[data-lmf-colls]');if(!n){return {};}try{return JSON.parse(n.textContent)||{};}catch(e){return {};}}
function fromText(t){
 t=(t||'').toLowerCase();
 if(!E){if(/iphone[-\s_]?18[-\s_]?pro[-\s_]?max/.test(t)){return {handle:'iphone-18-pro-max',label:'iPhone 18 Pro Max'};}if(/iphone[-\s_]?17[-\s_]?pro[-\s_]?max/.test(t)){return {handle:'iphone-17-pro-max',label:'iPhone 17 Pro Max'};}return null;}
 if(/iphone[-\s_]?13[-\s_]?14/.test(t)){return E.fromHandle('iphone-13-14');}
 var m=t.match(/iphone[-\s_]?(1[3-9])(?:[-\s_]?(pro[-\s_]?max|pro|plus))?/);
 if(!m){return null;}
 return E.fromHandle('iphone-'+m[1]+(m[2]?'-'+m[2].replace(/[\s_]+/g,'-'):''));
}
function refPath(){try{var r=new URL(doc.referrer);if(r.origin===location.origin){return decodeURIComponent(r.pathname);}}catch(e){}return '';}
var rp=refPath();
var fromAll=/^\/collections\/toutes-les-coques/.test(rp);
var fromOtherColl=/^\/collections\//.test(rp)&&!fromAll;
var stored=E?E.read():null;
function wanted(){
 var m=null;
 try{m=fromText(new URL(location.href).searchParams.get('model')||'');}catch(e){}
 if(m){return m;}
 if(fromOtherColl){m=fromText(rp);if(m){return m;}}
 return stored;
}
var color='';
try{color=(new URL(location.href).searchParams.get('color')||'').trim();}catch(e){}
var hasVariant=false;
try{hasVariant=!!new URL(location.href).searchParams.get('variant');}catch(e){}
var target=hasVariant?null:wanted();
var chosen=hasVariant&&fromOtherColl;
var done=false,doneC=!color,tries=0,gateReady=false,lastPicked='';
function radios(){return [].slice.call(doc.querySelectorAll('input[type=radio][data-option-name="Modèle iPhone"]'));}
function pick(value){
 var hit=false;
 [].slice.call(doc.querySelectorAll('input[type=radio]')).forEach(function(i){
  if((i.value||'').trim()===value){hit=true;if(!i.checked){i.click();}}
 });
 if(!hit){
  [].slice.call(doc.querySelectorAll('select')).forEach(function(s){
   [].slice.call(s.options).forEach(function(o){
    if((o.value||'').trim()===value){
     hit=true;
     if(s.value!==o.value){s.value=o.value;s.dispatchEvent(new Event('change',{bubbles:true}));}
    }
   });
  });
 }
 return hit;
}
/* --- messages sous le choix du modèle --- */
var note=null,info=null;
function groupOf(r){return r.closest('fieldset')||r.parentElement;}
function after(el){var rs=radios();if(!rs.length){return;}var g=groupOf(rs[0]);if(g&&g.parentNode&&el.parentNode!==g.parentNode){g.parentNode.insertBefore(el,g.nextSibling);}}
function modelList(){var vs=radios().map(function(r){return (r.value||'').trim();});if(vs.length<2){return vs.join('');}return vs.slice(0,-1).join(', ')+' ou '+vs[vs.length-1];}
function ensureNote(){
 var rs=radios();if(!rs.length){return;}
 if(!note){
  note=doc.createElement('p');note.className='lmodel-note';note.setAttribute('role','status');
  note.textContent='Choisissez votre iPhone : '+modelList()+'.';
  note.style.cssText='margin:8px 0 0;font-size:13px;color:#8a6d2f';
 }
 after(note);
}
function dropNote(){if(note&&note.parentNode){note.parentNode.removeChild(note);}note=null;}
function setInfo(html){
 if(!info){info=doc.createElement('div');info.className='lmodel-info';info.setAttribute('role','status');info.style.cssText='margin:10px 0 0;padding:10px 12px;border:1px solid #e3d6b6;border-radius:10px;background:#fbf6ea;font-size:13.5px;line-height:1.5;color:#3a342a';}
 info.innerHTML=html;after(info);
 var b=info.querySelector('[data-lmodel-change]');if(b){b.addEventListener('click',changeModel);}
}
function dropInfo(){if(info&&info.parentNode){info.parentNode.removeChild(info);}info=null;}
function esc(t){var d=doc.createElement('span');d.textContent=t;return d.innerHTML;}
var LINK='color:#916915;font-weight:600;text-decoration:underline;text-underline-offset:3px;background:none;border:0;padding:0;font:inherit;cursor:pointer';
function showRetained(m){setInfo('Modèle retenu : <b>'+esc(m.label)+'</b> · <button type=\'button\' data-lmodel-change style=\''+LINK+'\'>Changer de modèle</button>');}
function showMismatch(m,soldout){
 var c=colls()[E?E.collHandle(m):''],msg;
 if(soldout){msg='Cette coque est actuellement épuisée pour votre <b>'+esc(m.label)+'</b>.';}
 else{msg='Cette coque n’est pas proposée pour votre <b>'+esc(m.label)+'</b>.';}
 var more=(c&&c.count>0)?' <a href=\''+c.url+'\' style=\''+LINK+'\'>Voir les coques compatibles avec l’'+esc(m.label)+'</a> ·':' Aucune coque compatible avec ce modèle n’est disponible pour le moment.';
 var all=colls()['toutes-les-coques'];
 setInfo(msg+more+(all?' <a href=\''+all.url+'\' style=\''+LINK+'\'>Voir toutes les coques</a> ·':'')+' <button type=\'button\' data-lmodel-change style=\''+LINK+'\'>Changer de modèle</button>');
}
function changeModel(){
 if(E){E.save(null);}
 stored=null;target=null;chosen=false;lastPicked='';
 dropInfo();
 radios().forEach(function(r){if(r.checked){r.checked=false;}});
 ensureNote();
 var rs=radios();if(rs[0]){try{groupOf(rs[0]).scrollIntoView({behavior:'smooth',block:'center'});}catch(x){}}
 doc.dispatchEvent(new CustomEvent('luxe:model-cleared'));
}
function clearModel(){
 if(chosen){return;}
 radios().forEach(function(r){if(r.checked){r.checked=false;}});
 ensureNote();
}
function setChosen(){
 if(chosen){return;}
 chosen=true;
 dropNote();
}
doc.addEventListener('click',function(e){
 var t=e.target;if(!t||!t.closest){return;}
 var lab=t.closest('label'),inp=(t.matches&&t.matches('input[type=radio]'))?t:(lab?lab.querySelector('input[type=radio]'):null);
 if(inp&&radios().indexOf(inp)>-1){
  var v=(inp.value||'').trim();
  if(E&&e.isTrusted){var nm=E.fromValue(v);if(nm){E.save(nm);stored=nm;lastPicked=v;}dropInfo();}
  setChosen();return;
 }
 if(chosen){return;}
 var sub=t.closest('form[action*="/cart/add"] [type=submit], form[action*="/cart/add"] [name=add], shopify-accelerated-checkout, .shopify-payment-button, [ref=addToCartButton], .add-to-cart-button');
 if(sub&&radios().length){
  e.preventDefault();e.stopImmediatePropagation();
  ensureNote();
  if(note){note.style.color='#b3261e';note.style.fontWeight='600';try{note.scrollIntoView({behavior:'smooth',block:'center'});}catch(x){}}
 }
},true);
doc.addEventListener('submit',function(e){
 if(chosen){return;}
 var f=e.target;if(!f||!f.matches||!f.matches('form[action*="/cart/add"]')){return;}
 if(radios().length){e.preventDefault();e.stopImmediatePropagation();ensureNote();if(note){note.style.color='#b3261e';note.style.fontWeight='600';}}
},true);
var mo=null,moT=0;
function watch(){
 if(mo||!window.MutationObserver){return;}
 mo=new MutationObserver(function(){
  window.clearTimeout(moT);moT=window.setTimeout(function(){
   if(!chosen){clearModel();}
   if(info&&!info.parentNode){after(info);}
   if(note&&!note.parentNode){after(note);}
  },60);
 });
 mo.observe(doc.body,{childList:true,subtree:true});
}
function applyTarget(){
 if(!target){return true;}
 var rs=radios();if(!rs.length){return false;}
 var hit=null;
 rs.forEach(function(r){if(!hit&&E&&E.matches(target,r.value)){hit=r;}});
 if(!E){rs.forEach(function(r){if(!hit&&(r.value||'').trim()===target.label.replace(/^iPhone\s*/,'')){hit=r;}});}
 if(!hit){showMismatch(target,false);return true;}
 if(hit.getAttribute('data-option-available')==='false'){showMismatch(target,true);return true;}
 if(pick((hit.value||'').trim())){chosen=true;dropNote();showRetained(target);return true;}
 return false;
}
function apply(){
 if(!done){done=applyTarget();}
 if(!doneC&&pick(color)){doneC=true;}
 if(done&&doneC&&radios().length){if(!chosen){clearModel();}gateReady=true;watch();}
}
function loop(){apply();tries++;if(!(done&&doneC&&gateReady)&&tries<14){window.setTimeout(loop,300);}}
if(doc.readyState==='loading'){doc.addEventListener('DOMContentLoaded',loop);}else{loop();}
window.LuxeModelGate={isChosen:function(){return chosen;},hasModel:function(){return radios().length>0;}};
})();
